import { useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Landing from './pages/Landing'
import Upgrade from './pages/Upgrade'
import PaymentCallback from './pages/PaymentCallback'
import Legal from './pages/Legal'



function App() {
  const [token, setToken] = useState(localStorage.getItem('atm_token'))

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login setToken={setToken} />} />
        <Route path="/register" element={<Register setToken={setToken} />} />
        <Route
          path="/dashboard"
          element={token ? <Dashboard /> : <Navigate to="/login" />}
        />
        <Route path="/upgrade" element={token ? <Upgrade /> : <Navigate to="/login" />} />
        <Route path="/payment/callback" element={<PaymentCallback />} />
        <Route path="/legal/:page" element={<Legal />} />

      </Routes>

    </BrowserRouter>
  )
}

export default App